module.exports = __webpack_public_path__ + "static/media/bg-pattern-heads.7429f9d5.webp";